import API from "../utilities/LocalApiProxy";

import React from "react";

import { openGlobalDialog } from "./globalEditDialogActions";

function listSmartFileAssociations() {
	return API.get("/user/smartFileAssociations");
}

function deleteSmartFileAssociations({ matterID, emailAddresses }) {
	// will either delete all assocations for a matter,
	// or a single association if provided an email
	return API.post("/user/smartFileAssociations/delete", {
		body: { matterID, emailAddresses },
	});
}
function deleteAllSmartFileAssociations() {
	// will either delete all assocations for a matter,
	// or a single association if provided an email
	return API.post("/user/smartFileAssociations/deleteAll");
}

function updateSmartFileAssociation({ emailAddress, matterID }) {
	return API.post("/user/smartFileAssociations/update", {
		body: { associationsList: [{ matterID, emailAddress }] },
	});
}

function showLexWorkplaceMatterSelectorDialog({
	smartFileAssociatedMatter,
	emailAddress,
	postSubmit,
}) {
	return function (dispatch) {
		openGlobalDialog(
			{
				label: "Change Smart-File Associated Matter",
				submitButtonLabel: "Update",
				mainText: (
					<span>
						Emails from{" "}
						<span style={{ fontFamily: "monospace" }}>
							{emailAddress}
						</span>{" "}
						will be automatically filed to this matter:
					</span>
				),
				extraButtonField: false,
				smartFileAssociatedMatter,
				type: "lxwMatterSelector",
			},
			(state) => {
				updateSmartFileAssociation({
					emailAddress: emailAddress,
					matterID: state.selectedMatter.value,
				}).then(() => {
					postSubmit();
				});
			},
			(state) => {
				const selectedMatterID = state.selectedMatter.value;

				return {
					// if user didnt change the matter, they cant "update"
					canSubmit:
						smartFileAssociatedMatter.matterID !== selectedMatterID,
				};
			}
		)(dispatch);
	};
}

function showDeleteAllSmartFileAssociationsConfirmDialog({ postSubmit }) {
	return function (dispatch) {
		openGlobalDialog(
			{
				label: "Delete all Smart-File Associations?",
				mainText: `This will permanently delete all of your saved email/matter Smart-File associations.  If you wish to proceed, please type "delete all" to confirm.`,
				value: "",
				placeHolder: `type "delete all" to confirm`,
				submitButtonLabel: "Delete All",
			},
			() => {
				deleteAllSmartFileAssociations().then(() => {
					postSubmit();
				});
			},
			(state) => {
				return {
					canSubmit: state.value === "delete all",
					erroMessage: "",
				};
			}
		)(dispatch);
	};
}

export {
	listSmartFileAssociations,
	deleteSmartFileAssociations,
	showLexWorkplaceMatterSelectorDialog,
	showDeleteAllSmartFileAssociationsConfirmDialog,
};
